import { render } from "./FormSwitch.vue?vue&type=template&id=feb3c100&scoped=true"
import script from "./FormSwitch.vue?vue&type=script&lang=js"
export * from "./FormSwitch.vue?vue&type=script&lang=js"

import "./FormSwitch.vue?vue&type=style&index=0&id=feb3c100&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb3c100"]])

export default __exports__